import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import logonameImg from '../assets/imgs/logoname.png';
import { mintTotal } from '../util/api';
import './Splash.css';

const TOTAL = 21000;

export default function Splash() {
  const navigate = useNavigate();
  const canvasRef = useRef(null);
  const countdownRef = useRef(null);
  const [remaining, setRemaining] = useState('—');
  const [mintedLabel, setMintedLabel] = useState('— minted');
  const [progress, setProgress] = useState(0);

  const resizeCanvas = () => {
    const canvas = canvasRef.current;
    const num = countdownRef.current;
    if (!canvas || !num) return;
    canvas.width = num.offsetWidth;
    canvas.height = num.offsetHeight;
  };

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');

    const drawPixelNoise = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      const blockSize = 6;
      for (let x = 0; x < canvas.width; x += blockSize) {
        if (Math.random() > 0.85) {
          const h =
            Math.floor(Math.random() * (canvas.height / blockSize)) * blockSize;
          const colors = ['#00ffff', '#ff0044', '#e53935', '#ffffff'];
          ctx.fillStyle = colors[Math.floor(Math.random() * colors.length)];
          ctx.globalAlpha = Math.random() * 0.6 + 0.2;
          ctx.fillRect(
            x,
            h,
            blockSize * (Math.floor(Math.random() * 4) + 1),
            blockSize,
          );
        }
      }
    };

    const noiseInterval = setInterval(drawPixelNoise, 80);
    window.addEventListener('resize', resizeCanvas);
    resizeCanvas();

    return () => {
      clearInterval(noiseInterval);
      window.removeEventListener('resize', resizeCanvas);
    };
  }, []);

  useEffect(() => {
    const updateCount = async () => {
      try {
        const data = await mintTotal();
        const minted = data.data || 0;
        const left = TOTAL - minted;
        const pct = (minted / TOTAL) * 100;
        const val = left.toLocaleString();

        setRemaining(val);
        setMintedLabel(`${minted.toLocaleString()} minted`);
        setProgress(pct);
        requestAnimationFrame(resizeCanvas);
      } catch (e) {
        console.error('Failed to fetch count:', e);
      }
    };

    updateCount();
    const countInterval = setInterval(updateCount, 30000);
    return () => clearInterval(countInterval);
  }, []);

  return (
    <main className='splash-page'>
      <div className='splash-content'>
        <img
          src={logonameImg}
          alt='The Eyes Are Always Watching'
          className='splash-logo-img'
        />
        <a
          href='https://x.com/theeyesbtc'
          target='_blank'
          rel='noreferrer'
          className='splash-twitter-link'
          aria-label='Twitter'
        >
          <svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
            <path d='M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.744l7.73-8.835L1.254 2.25H8.08l4.253 5.622zm-1.161 17.52h1.833L7.084 4.126H5.117z' />
          </svg>
        </a>
        <div className='splash-countdown-wrap'>
          <div className='splash-glitch-wrap'>
            <div
              className='splash-glitch-num'
              ref={countdownRef}
              data-text={remaining}
            >
              {remaining}
            </div>
            <canvas className='splash-glitch-canvas' ref={canvasRef} />
          </div>
          <div className='splash-countdown-label'>
            Mints Until The Bitcoin Golden Age Begins 💥
          </div>
        </div>
        <div className='splash-progress-wrap'>
          <div className='splash-progress-bar-outer'>
            <div
              className='splash-progress-bar-inner'
              style={{ width: `${progress}%` }}
            />
          </div>
          <div className='splash-progress-text'>
            <span>{mintedLabel}</span>
            <span>21,000 total supply</span>
          </div>
        </div>
        <div className='splash-cta-wrap'>
          <button
            type='button'
            className='splash-btn-mint'
            onClick={() => navigate('/mint')}
          >
            ENTER NOW TO MINT
          </button>
        </div>
      </div>
    </main>
  );
}
